// Globals
import { useState } from 'react';

// Modules
import { ChatContainer } from '@/modules/Chat';
import { SocketContainer } from '@/modules/Socket';
import { useSettings } from '@/modules/Settings';
import { DebuggerContainer } from '@/modules/Debugger';

// Components
import { LogoIcon, StarIcon } from '@/icons';
import {
  StyledChat,
  StyledChatButton,
  StyledContainer,
  StyledWidget,
  StyledWrapper,
  LauncherWrap,
  LauncherRing,
  LauncherButton,
  StyledInnerTooltip,
  StyledIconWrapper,
  AvatarBadge,
} from './WidgetContainerStyles';

// Helpers
import { DEBUG_TOOLS_ENABLED, DEFAULT_AGENT_NAME, DEFAULT_MAIN_COLOR } from '@/constants/common';

const WidgetContainer = () => {
  const [chatOpened, setChatToggle] = useState(false);
  const { settings } = useSettings();
  const mainColor = settings?.main_color ?? DEFAULT_MAIN_COLOR;
  const senderName = settings?.sender_name ?? DEFAULT_AGENT_NAME;

  const handleToggleChat = () => setChatToggle((prev) => !prev);

  return (
    <StyledWidget>
      {chatOpened && (
        <StyledChat>
          <SocketContainer>
            <ChatContainer onClose={handleToggleChat} />
            {DEBUG_TOOLS_ENABLED && <DebuggerContainer />}
          </SocketContainer>
        </StyledChat>
      )}
      {!chatOpened && (
        <StyledContainer>
          <LauncherWrap>
            <LauncherRing $primary={mainColor ?? ''} />
            <LauncherButton $primary={mainColor ?? ''} aria-label="Open chat" onClick={handleToggleChat}>
              <LogoIcon />
            </LauncherButton>
          </LauncherWrap>
          <StyledWrapper>
            <StyledChatButton onClick={handleToggleChat} data-tooltip="Chat with us">
              <StyledIconWrapper $primary={mainColor}>
                <LogoIcon />
                <AvatarBadge $primary={mainColor}>
                  <StarIcon />
                </AvatarBadge>
              </StyledIconWrapper>
              <StyledInnerTooltip>{`Hi! Need help finding a product? Ask ${senderName}.`}</StyledInnerTooltip>
            </StyledChatButton>
          </StyledWrapper>
        </StyledContainer>
      )}
    </StyledWidget>
  )
};

export default WidgetContainer;
